import * as React from "react";
const SvgFiRrKnife = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-knife_svg__a)">
      <path
        fill="#062147"
        d="M22.68.156a2.22 2.22 0 0 0-2.446.558L.266 22.32a1 1 0 0 0 1.469 1.357l5.178-5.6C19.92 16.92 24.011 6.243 24 2.5A2.2 2.2 0 0 0 22.68.156M22 2.5c0 1.876-2.32 11.13-12.939 13.25L21.694 2.08a.23.23 0 0 1 .245-.066c.11.007.045.41.061.486"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-knife_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrKnife;
